
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Table } from "@common/src/utils/decorator";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import TableEnableFlag from "@/components/scope/table-enable-flag.vue";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import { formDownload, addCurrencyUnit } from "@common/src/utils/tools";
const base = namespace("base");
const partsCategory = namespace("parts-category");
const employee = namespace("employee");
@Component({
  components: { TableEnableFlag }
})
@Table("loadListData")
export default class PushMoneyQuery extends Vue {
  @partsCategory.Action getCategoryList;
  @base.Action getDictionaryList;
  @employee.Action getStaffCommissionPage;
  @employee.State pushMoneyGather;
  dayjs = dayjs;
  addCurrencyUnit = addCurrencyUnit;
  searchForm = {
    staffName: "",
    businessName: "",
    searchKey: "",
    commissionCategory: "",
    orderCreateTimeStart: undefined,
    orderCreateTimeEnd: undefined,
    orderSettlementTimeStart: dayjs().format("YYYYMMDD"),
    orderSettlementTimeEnd: dayjs().format("YYYYMMDD")
  };
  hideCost: boolean = true;
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  sortForm: {};
  partsList: any[] = [];
  pushMoneyType = [];
  get searchList() {
    return [
      {
        label: t("v210801.employee-name"),
        type: "input",
        value: this.searchForm.staffName || "",
        prop: "staffName"
      },
      {
        label: t("v210831.commission-type"),
        type: "select",
        value: "",
        prop: "commissionCategory",
        selectList: this.pushMoneyType
      },
      {
        label: t("v210831.name-of-project-parts"),
        type: "input",
        value: "",
        prop: "businessName"
      },
      {
        label: t("v210831.document-keyword"),
        type: "input",
        value: "",
        placeholder: t("v210831.license-plate-number-mobile-vin"),
        prop: "searchKey"
      },
      {
        label: t("v210831.document-creation-date"),
        type: "daterange",
        value:
          (this.searchForm.orderCreateTimeStart && [
            this.searchForm.orderCreateTimeStart,
            this.searchForm.orderCreateTimeEnd
          ]) ||
          "",
        prop: "orderCreateTimeStart"
      },
      {
        label: t("v210831.document-settlement-date"),
        type: "daterange",
        defaultVlaue: [dayjs().format("YYYYMMDD"), dayjs().format("YYYYMMDD")],
        value: this.getSearch.flag
          ? [this.searchForm.orderSettlementTimeStart, this.searchForm.orderSettlementTimeEnd]
          : [dayjs().format("YYYYMMDD"), dayjs().format("YYYYMMDD")],
        prop: "orderSettlementTimeStart"
      }
    ];
  }
  categoryList: any[] = [];
  getSearch = {
    flag: true,
    name: "",
    TimeStart: undefined,
    TimeEnd: undefined,
    crateStart: undefined,
    createEnd: undefined
  };
  created() {
    this.init();
  }
  async init() {
    let getLocal = JSON.parse(localStorage.getItem("pushMoneyGather"));
    if (getLocal && getLocal.flag) {
      this.getSearch = getLocal;
      this.searchForm.staffName = getLocal.name;
      this.searchForm.orderCreateTimeStart = getLocal.createStart;
      this.searchForm.orderCreateTimeEnd = getLocal.createEnd;
      this.searchForm.orderSettlementTimeStart = getLocal.TimeStart;
      this.searchForm.orderSettlementTimeEnd = getLocal.TimeEnd;
      localStorage.setItem("pushMoneyGather", JSON.stringify({ ...getLocal, flag: false }));
    }
    this.loadListData();
    const res = await this.getDictionaryList("commission_category");
    this.pushMoneyType = res;
    const data = await this.getCategoryList();
    this.categoryList = this.addLeafFlag(this.$safeValue(data, "data", []));
  }
  handleLinkPartsDetail(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.orderNo}`
    });
    window.open(href, "_blank");
  }
  inventoryQty: any = "";
  inventoryAmount: any = "";
  @Table.LoadDataMethod()
  loadListData() {
    return this.getStaffCommissionPage({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize,
      staffName: this.searchForm.staffName
    }).then(data => {
      this.partsList = this.$safeValue(data, "data.list", []);
      this.inventoryQty = data.data.commissionSum;
      this.inventoryAmount = data.data.commissionTotal;
      return data;
    });
  }
  addLeafFlag(list) {
    const f = function (list) {
      list.forEach(item => {
        if (!item.children || item.children.length < 1) {
          delete item.children;
        } else {
          f(item.children);
        }
      });
    };
    f(list);
    return list;
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "orderCreateTimeStart") {
          this.searchForm["orderCreateTimeStart"] = item.value ? item.value[0] : "";
          this.searchForm["orderCreateTimeEnd"] = item.value ? item.value[1] : "";
        } else if (item.prop === "orderSettlementTimeStart") {
          this.searchForm["orderSettlementTimeStart"] = item.value ? item.value[0] : "";
          this.searchForm["orderSettlementTimeEnd"] = item.value ? item.value[1] : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  handleDetail(row) {
    this.$router.push({
      name: "employeePushMoneyDetail",
      params: {
        row: row
      }
    });
  }
  handleExportData() {
    formDownload(`${window.API_URL}/staff/commission/exportStaffCommissionPage`, this.searchForm);
  }
}
